import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { mediaFileTypeExtensions } from "constants/constants";
import { useStyles } from "./RCAMediaPreviewer.styles";
import { IMediaPreviewer } from "./RCAMediaPreviewerInterfaces";
import RCAConfirmDeleteModal from "../RCAConfirmDeleteModal/RCAConfirmDeleteModal";
import { useTranslation } from "react-i18next";
import { removeFileExtension } from "utilities/utilities";

export const RCAMediaPreviewer = ({ mediaFile, handleDelete, canDelete }: IMediaPreviewer) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [isHovered, setIsHovered] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);

    const isVideo = Object.keys(mediaFileTypeExtensions).some(
        (type) =>
            type.startsWith("video/") &&
            mediaFileTypeExtensions[type as keyof typeof mediaFileTypeExtensions].includes(`.${mediaFile.media_type}`),
    );

    const openModal = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        setOpenDeleteModal(true);
    };

    return (
        <a
            target="_blank"
            rel="noreferrer"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={classes.mediaLink}
            key={mediaFile.media_id}
            href={mediaFile.media_url}
        >
            <div>
                {isVideo ? (
                    <video controls className={classes.mediaFile}>
                        <source src={mediaFile.media_url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <img
                        src={mediaFile.media_url}
                        alt={mediaFile.name || "Media"}
                        key={mediaFile.media_id}
                        className={classes.mediaFile}
                    />
                )}
                <p className={classes.mediaLegend}>{removeFileExtension(mediaFile.name)}</p>
            </div>
            {isHovered && canDelete && <DeleteIcon className={classes.deleteIcon} onClick={openModal} />}
            <RCAConfirmDeleteModal
                open={openDeleteModal}
                onClose={() => setOpenDeleteModal(false)}
                onDeleteItem={handleDelete}
                title={t("rca.rca_library.rca_detail.media.delete_modal.title")}
                warning={t("rca.rca_library.rca_detail.media.delete_modal.warning")}
                confirm={t("rca.rca_library.rca_detail.media.delete_modal.confirm")}
            />
        </a>
    );
};
